'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of account web
 */ const AccountWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "31.6211",
                width: "63.9459",
                height: "37.2433",
                rx: "3.46892",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9453 62.1196V65.3986C19.9453 67.3144 21.4984 68.8675 23.4142 68.8675H80.4223C82.3382 68.8675 83.8913 67.3144 83.8913 65.3986V62.1196H19.9453Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1602",
                y: "68.8594",
                width: "19.6757",
                height: "6.04325",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "74.7637",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.2371 46.5173C58.2371 46.5173 58.2371 46.5392 58.2371 46.5611C58.2371 46.7363 57.97 50.4151 53.3626 52.0793V49.7801L56.1448 46.802C56.3897 46.5392 56.3897 46.1231 56.1003 45.8604C55.8332 45.6195 55.4103 45.6195 55.1432 45.9042L53.3626 47.8312V45.8604C53.3626 45.8604 53.3626 45.8604 53.3626 45.8385C53.5852 45.3348 54.6536 43.364 57.28 43.364C57.3022 43.364 57.3245 43.364 57.3468 43.364C58.3929 44.5903 58.2371 46.4954 58.2371 46.5173ZM52.0272 47.8312L50.2243 45.9042C49.9795 45.6414 49.5566 45.6195 49.2895 45.8604C49.0224 46.1012 49.0001 46.5392 49.245 46.802L52.0272 49.7801V52.0574C47.4198 50.3932 47.175 46.6925 47.1527 46.5392C47.1527 46.5173 47.1527 46.5173 47.1527 46.4954C47.1527 46.4735 46.9747 44.5684 48.0208 43.3421C48.043 43.3421 48.0653 43.3421 48.1098 43.3421C50.7585 43.3421 51.8046 45.3348 52.0272 45.8166C52.0272 45.8166 52.0272 45.8166 52.0272 45.8385V47.8312ZM58.148 42.2253C58.0367 42.1158 57.8809 42.0502 57.7251 42.0283C55.21 41.875 53.5629 43.145 52.6949 44.3275C51.8269 43.145 50.202 41.875 47.6647 42.0283C47.5089 42.0283 47.3531 42.1158 47.2418 42.2253C45.617 43.8239 45.795 46.364 45.8173 46.6049C45.8173 46.7801 45.9286 48.0282 46.7521 49.4735C47.5311 50.8531 49.1782 52.6706 52.4501 53.5903C52.4723 53.5903 52.4946 53.5903 52.4946 53.6122C52.5168 53.6122 52.5168 53.6122 52.5391 53.6122C52.5614 53.6122 52.5614 53.6122 52.5836 53.6122C52.6059 53.6122 52.6504 53.6122 52.6726 53.6122C52.6949 53.6122 52.7394 53.6122 52.7617 53.6122C52.7839 53.6122 52.7839 53.6122 52.8062 53.6122C52.8284 53.6122 52.8284 53.6122 52.8507 53.6122C52.873 53.6122 52.8952 53.6122 52.9175 53.5903C58.9938 51.9041 59.528 47.0866 59.5503 46.6268C59.5725 46.4954 59.7951 43.8677 58.148 42.2253Z",
                fill: theme.ds5.asset.grey["700"]
            })
        ]
    });
};

exports.AccountWeb = AccountWeb;
//# sourceMappingURL=AccountWeb.cjs.map
